import { Redirect } from "react-router-dom";
import { Mui } from "@leap4/frontend";
import { useCampaignScope } from "../../scope/CampaignScopeProvider";
import { urlService } from "../../routing/urlsService";
import Projection from "./index";

const { Alert, Button, Typography } = Mui;

export const ProjectionRoute = () => {
    const { campaign, status, configStatus, projectionEnabled, reloadConfig } = useCampaignScope();
    if (status === "error") return <Alert severity="error">Couldn't load campaign access.</Alert>;
    if (status === "ready" && !campaign) return <Redirect to={urlService.dashboard()} />;
    if (configStatus === "error") {
        return <Alert severity="error" action={<Button color="inherit" onClick={reloadConfig}>Retry</Button>}>Couldn't load projection settings.</Alert>;
    }
    if (status !== "ready" || configStatus !== "ready") return <Typography color="text.secondary">Loading campaign settings…</Typography>;
    if (!projectionEnabled) return <Redirect to={urlService.dashboard()} />;
    return <Projection key={campaign} />;
};
